import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Component/Login";
import SignupRequest from "./pages/SignupRequest";
import SubscriptionCheckout from "./pages/SubscriptionCheckout";
import SubscriptionReturn from "./pages/SubscriptionReturn";
import SignupRequests from "./pages/SignupRequests";
import MyAccount from "./pages/MyAccount";
// import Reservations from "./Component/Reservations";
// import ReservationApply from "./Component/ReservationApply";
import CarInfo from "./Component/CarInfo";
import CarAddForm from "./Component/CarAddForm";
import SmsSenderNumber from "./Component/SmsSenderNumber";
import UserManagement from "./Component/UserManagement";
import UserAddForm from "./Component/UserAddForm";
import UserEditForm from "./Component/UserEditForm";
import OperationStatus from "./Component/OperationStatus";
import Schedule from "./Component/ConfirmedSchedule";
import ProtectedRoute from "./components/ProtectedRoute";
import ReservationSearch from "./Component/ReservationSearch";
import HolidayInfo from "./Component/HolidayInfo";
import HolidayAdd from "./Component/HolidayAddForm";  
import { AuthProvider, useAuth } from "./components/AuthProvider";
import CarEditPage from "./Component/CarEditPage";
import DispatchForm from "./Component/DispatchForm";
import CarExpenses from "./pages/Unpaid/CarExpenses";
import CarExpenseForm from "./pages/Unpaid/CarExpenseForm";
import RoleProtectedRoute from "./components/RoleProtectedRoute";



// ✅ pages 폴더에서 가져오기
import Reservations from "./pages/ReservationManager";
import ReservationApply from "./pages/ReservationForm";
import UnpaidDetail from './pages/Unpaid/UnpaidDetail';
import SalaryInput from "./pages/SalaryInput";
import CarInstallments from "./pages/CarInstallments";
import CarInstallmentDetail from "./pages/CarInstallmentDetail";
import MaintenanceViewPage from "./pages/MaintenanceViewPage";
import ReservationGroupEdit from "./pages/ReservationGroupEdit";
import DriversList from "./pages/DriversList";
import DriverAdd from "./pages/DriverAdd";
import DriverEdit from "./pages/DriverEdit";
import ChangePassword from "./pages/ChangePassword";
import BusHubList from "./pages/BusHubList";
import BusHubNew from "./pages/BusHubNew";
import BusHubDetail from "./pages/BusHubDetail";
import BusHubManage from "./pages/BusHubManage";
import ReservationCalendar from "./pages/ReservationCalendar"; // ✅ 추가
import DriverHolidays from "./pages/DriverHolidays";
import DriverHolidaysNew from "./pages/DriverHolidaysNew";
import CarSettlements from './pages/CarSettlements';
import CarSettlementDetail from "./pages/CarSettlementDetail";
import Receipts from "./pages/Receipts";
import Safety from './pages/Safety';
import SafetyNew from "./pages/SafetyNew";
import SafetyEdit from "./pages/SafetyEdit";
import MonthlyClosing from './pages/MonthlyClosing';
import BugReport from "./pages/bugReport";
import AiApprovals from "./pages/AiApprovals";
import AiOpsAssistant from "./Component/AiOpsAssistant";
import TossReturn from "./pages/TossReturn";
import TossFail from "./pages/TossFail";
import OffBusCheck from "./pages/OffBusCheck";
import BusDispatchRules from "./pages/BusDispatchRules";
import BusAvailabilityTest from "./pages/BusAvailabilityTest";
import KakaoSales from "./pages/KakaoSales";
import BusInspectionReservations from "./pages/BusInspectionReservations";
import AppNotices from "./pages/AppNotices";
import AppNoticeDetail from "./pages/AppNoticeDetail";
import SiteFooter from "./Component/SiteFooter";


function AuthenticatedAssistant() {
  const { loading, user, subscriptionAccess } = useAuth();
  return !loading && user && !subscriptionAccess?.requirePayment ? <AiOpsAssistant /> : null;
}

function SignupAdminRoute({ children }) {
  const { loading, user, profile } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.email?.trim().toLowerCase() !== "backis87@gmail.com" || profile?.role !== "operator") {
    return <Navigate to="/reservations" replace />;
  }
  return children;
}

function App() {
  return (
    <AuthProvider>
    <Router>
      <div className="flex min-h-screen flex-col">
      <div className="flex-1">
      <Routes>
        {/* 로그인 */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup-request" element={<SignupRequest />} />
        <Route path="/subscription" element={<SubscriptionCheckout />} />
        <Route path="/subscription/success" element={<SubscriptionReturn />} />
        <Route path="/subscription/fail" element={<SubscriptionReturn />} />
        <Route path="/signup-requests" element={<SignupAdminRoute><SignupRequests /></SignupAdminRoute>} />
        <Route path="/my-account" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />

        {/* 기본 리다이렉트 */}
        <Route path="/" element={<Navigate to="/reservations" />} />

        <Route path="/unpaid/car-expenses" element={<ProtectedRoute><CarExpenses /></ProtectedRoute>} />
        <Route path="/car-expenses/add" element={<ProtectedRoute><CarExpenseForm /></ProtectedRoute>} />
        <Route path="/unpaid/accounts-receivable" element={<ProtectedRoute><UnpaidDetail /></ProtectedRoute>} />
        <Route path="/salary" element={<ProtectedRoute><SalaryInput /></ProtectedRoute>} />
        <Route path="/car-installments" element={<ProtectedRoute><CarInstallments /></ProtectedRoute>} />
        <Route path="/car-installments/:carNumber" element={<ProtectedRoute><CarInstallmentDetail /></ProtectedRoute>} />
        <Route path="/car-settlements" element={<ProtectedRoute><CarSettlements /></ProtectedRoute>} />
        <Route path="/settlements/:carNumber" element={<ProtectedRoute><CarSettlementDetail /></ProtectedRoute>} />
        <Route path="/receipts" element={<ProtectedRoute><Receipts /></ProtectedRoute>} />

        
        {/* ✅ 예약 현황 (콤보 전환 포함) */}
        {/* 배차처리 페이지는 first/operator만 허용 */}
        <Route
          path="/reservations"
          element={
            <ProtectedRoute allowRoles={["first", "operator"]}>
              <Reservations />
            </ProtectedRoute>
          }
        />

        {/* ✅ 예약 등록 (콤보 전환 포함) */}
        <Route path="/reservation-apply" element={<ProtectedRoute><ReservationApply /></ProtectedRoute>} />

        <Route path="/reservation-search" element={<ProtectedRoute><ReservationSearch /></ProtectedRoute>} />
        <Route path="/off-bus-check" element={<ProtectedRoute><OffBusCheck /></ProtectedRoute>} />
        <Route path="/bus-dispatch-rules" element={<ProtectedRoute><BusDispatchRules /></ProtectedRoute>} />
        <Route path="/bus-availability-test" element={<ProtectedRoute><BusAvailabilityTest /></ProtectedRoute>} />
        <Route path="/reservation-edit/:groupId" element={<ProtectedRoute><ReservationGroupEdit /></ProtectedRoute>} />

        <Route path="/dispatch-form/:id" element={<ProtectedRoute><DispatchForm /></ProtectedRoute>} />
        <Route path="/dispatch/:type/:id" element={<ProtectedRoute><DispatchForm /></ProtectedRoute>} />
        {/* 차량 정보 */}
        <Route path="/car-info" element={<ProtectedRoute><CarInfo /></ProtectedRoute>} />
        <Route path="/car-add" element={<ProtectedRoute><CarAddForm /></ProtectedRoute>} />
        <Route path="/car-edit/:id" element={<ProtectedRoute><CarEditPage /></ProtectedRoute>} />
        <Route path="/salary-add/:driverName" element={<ProtectedRoute><SalaryInput /></ProtectedRoute>} />

        
        <Route path="/drivers" element={<ProtectedRoute><DriversList /></ProtectedRoute>} />
        <Route path="/drivers/add" element={<ProtectedRoute><DriverAdd /></ProtectedRoute>} />
        <Route path="/drivers/:id/edit" element={<ProtectedRoute><DriverEdit /></ProtectedRoute>} />

        {/* 사용자 관리 */}
        <Route path="/user-management" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
        <Route path="/user-add" element={<ProtectedRoute><UserAddForm /></ProtectedRoute>} />
        <Route path="/user-edit/:source/:id" element={<ProtectedRoute><UserEditForm /></ProtectedRoute>} />

        {/* 운행 현황 및 일정 */}
        <Route path="/operation" element={<ProtectedRoute><OperationStatus /></ProtectedRoute>} />
        <Route path="/schedule" element={<ProtectedRoute><Schedule /></ProtectedRoute>} />

        <Route path="/holiday-info" element={<ProtectedRoute><HolidayInfo /></ProtectedRoute>} />
        <Route path="/holiday-add" element={<ProtectedRoute><HolidayAdd /></ProtectedRoute>} />

        <Route path="/driver-holidays" element={<ProtectedRoute><DriverHolidays /></ProtectedRoute>} />
        <Route
          path="/driver-holidays/new"
          element={
            <ProtectedRoute>
              <DriverHolidaysNew />
            </ProtectedRoute>
          }
        />

        <Route path="/maintenance" element={<ProtectedRoute><MaintenanceViewPage /></ProtectedRoute>} />

        {/* 문자발신번호 설정 */}
        <Route path="/sms-sender" element={<ProtectedRoute><SmsSenderNumber /></ProtectedRoute>} />

        
        <Route path="/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />


        <Route path="/safety" element={<ProtectedRoute><Safety /></ProtectedRoute>} />
        <Route path="/safety/new" element={<ProtectedRoute><SafetyNew /></ProtectedRoute>} />
        <Route path="/safety/:id" element={<ProtectedRoute><SafetyEdit /></ProtectedRoute>} />
        <Route path="/bus-inspections" element={<ProtectedRoute><BusInspectionReservations /></ProtectedRoute>} />
        <Route path="/app-notices" element={<ProtectedRoute allowRoles={["first", "second", "operator"]}><AppNotices /></ProtectedRoute>} />
        <Route path="/app-notices/:id" element={<ProtectedRoute allowRoles={["first", "second", "operator"]}><AppNoticeDetail /></ProtectedRoute>} />


        <Route
          path="/bus-hub"
          element={
            <RoleProtectedRoute allow={["first", "operator"]}>
              <BusHubList />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/bus-hub/new"
          element={
            <RoleProtectedRoute allow={["first", "operator"]}>
              <BusHubNew />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/bus-hub/:id"
          element={
            <RoleProtectedRoute allow={["first", "operator"]}>
              <BusHubDetail />
            </RoleProtectedRoute>
          }
        />
        <Route
          path="/bus-hub/:id/manage"
          element={
            <RoleProtectedRoute allow={["first", "operator"]}>
              <BusHubManage />
            </RoleProtectedRoute>
          }
        />



        
        <Route
          path="/reservation-calendar"
          element={
            <ProtectedRoute>
              <ReservationCalendar />
            </ProtectedRoute>
          }
        />

        <Route path="/monthly-closing" element={<ProtectedRoute><MonthlyClosing /></ProtectedRoute>} />

        <Route
          path="/ai-approvals"
          element={
            <ProtectedRoute>
              <AiApprovals />
            </ProtectedRoute>
          }
        />
        <Route
          path="/kakao-sales"
          element={
            <ProtectedRoute allowRoles={["first", "operator"]}>
              <KakaoSales />
            </ProtectedRoute>
          }
        />

        <Route path="/bug-report" element={<ProtectedRoute><BugReport /></ProtectedRoute>} />
        <Route path="/toss/success" element={<ProtectedRoute><TossReturn /></ProtectedRoute>} />
        <Route path="/toss/fail" element={<ProtectedRoute><TossFail /></ProtectedRoute>} />
      </Routes>
      </div>
      <AuthenticatedAssistant />
      <SiteFooter />
      </div>
    </Router>
    </AuthProvider>
  );
}

export default App;
